module.exports = __webpack_public_path__ + "img/缺省.c9835800.svg";